module.exports = __webpack_public_path__ + "static/media/logotype_white.4dcfd639.svg";